import { call, put, takeEvery, select, delay } from 'redux-saga/effects';
import { wrapPageSagaWithErrorHandler } from 'core/page/sagas';
import homeActions from './actions';

function* start() {
  let request;
  let searchParams;
  const jscEnabled = yield select((state) => state.session.meta.configs.jsc_enabled);
  if (jscEnabled) {
    yield delay(500);
    const deviceToken = yield select((state) => state.ui.deviceToken);
    ({ request, searchParams } = homeActions.getStartRequest(deviceToken));
  } else {
    ({ request, searchParams } = homeActions.getStartRequest());
  }

  const response = yield call(request);
  const { data } = response;
  yield put(homeActions.startSuccess(data, searchParams));
}

function* fetch({ payload }) {
  const currData = yield select(
    ({ home }) =>
      home[payload.id] &&
      home[payload.id][payload.endpoint] &&
      home[payload.id][payload.endpoint].data,
  );
  if (!currData) {
    const response = yield call(payload.request);
    const { data } = response;
    yield put({
      payload: {
        ...payload,
        data: data.data,
        meta: data.meta,
      },
      type: homeActions.FETCH_SUCCESS,
    });
  }
}

function* getPlaid({ payload }) {
  const response = yield call(payload.request);
  const { data } = response;
  payload.cb(data.data);
  yield put({ type: homeActions.GET_PLAID_SUCCESS });
}

export default [
  takeEvery(homeActions.FETCH, wrapPageSagaWithErrorHandler(fetch)),
  takeEvery(homeActions.GET_PLAID, wrapPageSagaWithErrorHandler(getPlaid)),
  takeEvery(homeActions.START, wrapPageSagaWithErrorHandler(start)),
];
